import { render, staticRenderFns } from "./BoNavbar.vue?vue&type=template&id=70c19072&"
import script from "./BoNavbar.vue?vue&type=script&lang=js&"
export * from "./BoNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports